import type {
  TPaymentMethod,
  TPaymentMethodServer,
  TPaymentMethodData,
  TPaymentMethodDataServer,
  TPaymentMethodCredential,
  TPaymentMethodCredentialServer,
  TConfigImagesResponse,
} from '../../store/types';

const methodDataAdapter = (data: TPaymentMethodDataServer): TPaymentMethodData => ({
  blockchain: data.blockchain ? {
    network: data.blockchain.network,
    enabled: data.blockchain.enabled ?? true,
    addressField: data.blockchain.address_field,
    requiredConfirmations: data.blockchain.required_confirmations,
  } : undefined,
  step1: {
    title: data.step1.title,
    options: data.step1.options,
  },
  step2: {
    title: data.step2.title,
    mainText: data.step2.main_text,
  },
  step3: {
    title: data.step3.title,
  },
  confirmation: {
    type: data.confirmation.type,
    fileText: data.confirmation.file_text,
    additionalText: data.confirmation.additional_text,
    phoneCountry: data.confirmation.phone_country,
  },
});

const methodCredentialAdapter = (credential: TPaymentMethodCredentialServer): TPaymentMethodCredential => ({
  id: credential.id,
  fields: credential.fields,
  validFor: credential.valid_for,
  limit: credential.limit,
  shopId: credential.shop_id,
  exceptPayerId: credential.except_payer_id,
  forPayerId: credential.for_payer_id,
});

export const paymentMethodsAdapter = (items: TPaymentMethodServer[]): TPaymentMethod[] => {
  const paymentMethods: TPaymentMethod[] = items.map((item) => ({
    id: item.id,
    key: item.key,
    name: item.name,
    refillPercent: Number(item.refill_percent),
    additionalPercent: Number(item.additional_percent),
    paymentExpireMinutes: item.payment_expire_minutes,
    minRefill: item.min_refill,
    maxRefill: item.max_refill,
    currency: item.currency,
    active: item.active,
    useUniqueAmount: item.use_unique_amount ?? false,
    uniqueAmountStep: Number(item.unique_amount_step ?? 0.01),
    mode: item.mode,
    remoteMethodId: item.remote_method_id,
    conversionPairId: item.conversion_pair_id,
    remoteMethodName: item.remote_method_name,
    paymentSystemName: item.payment_system_name,
    data: item.data ? methodDataAdapter(item.data) : null,
    credentials: item.credentials.map(methodCredentialAdapter),
  }));

  return paymentMethods;
};

export const paymentMethodsGetImagesAdapter = (res: TConfigImagesResponse): string[] => {
  const items = res.items;
  const result = items.map((item) => item.filename);

  return result;
};
